// extracted by mini-css-extract-plugin
export default {"rating":"NA-z","numberOfStars":"OA-z","count":"PA-z","barGraphSpacing":"QA-z","barGraph":"RA-z"};